var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_478_2304)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 69,
    height: 70,
    rx: 34.5,
    fill: "#223F9E",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_2304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6871 25.236C41.4203 25.2564 40.1811 25.6231 39.0947 26.2991C38.0083 26.9751 37.1131 27.9364 36.4996 29.086C35.8861 27.9364 34.9909 26.9751 33.9045 26.2991C32.8181 25.6231 31.5789 25.2564 30.3121 25.236C28.2926 25.327 26.39 26.2431 25.0198 27.7842C23.6497 29.3254 22.9234 31.3662 22.9996 33.461C22.9996 38.7658 28.3838 44.5595 32.8996 48.4876C33.9078 49.3663 35.1826 49.848 36.4996 49.848C37.8166 49.848 39.0913 49.3663 40.0996 48.4876C44.6153 44.5595 49.9996 38.7658 49.9996 33.461C50.0758 31.3662 49.3495 29.3254 47.9793 27.7842C46.6092 26.2431 44.7065 25.327 42.6871 25.236ZM38.654 46.7026C38.0509 47.2292 37.2879 47.518 36.4996 47.518C35.7112 47.518 34.9482 47.2292 34.3452 46.7026C28.565 41.6731 25.2496 36.8478 25.2496 33.461C25.1727 31.9848 25.6617 30.537 26.6101 29.4333C27.5585 28.3296 28.8892 27.6595 30.3121 27.5693C31.7349 27.6595 33.0657 28.3296 34.0141 29.4333C34.9624 30.537 35.4515 31.9848 35.3746 33.461C35.3746 33.7704 35.4931 34.0671 35.7041 34.2859C35.9151 34.5047 36.2012 34.6276 36.4996 34.6276C36.798 34.6276 37.0841 34.5047 37.2951 34.2859C37.5061 34.0671 37.6246 33.7704 37.6246 33.461C37.5477 31.9848 38.0367 30.537 38.9851 29.4333C39.9335 28.3296 41.2642 27.6595 42.6871 27.5693C44.1099 27.6595 45.4407 28.3296 46.3891 29.4333C47.3374 30.537 47.8265 31.9848 47.7496 33.461C47.7496 36.8478 44.4342 41.6731 38.654 46.698V46.7026Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_478_2304",
    x: 0,
    y: 0,
    width: 77,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.515609 0 0 0 0 0.515609 0 0 0 0 0.515609 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_478_2304"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_478_2304",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_2304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.fb30232a73a0ad70f5114b78330513a1.svg";
export { ForwardRef as ReactComponent };